import React, {useState, useEffect} from 'react';
import bridge from '@vkontakte/vk-bridge';
import {
  Button,
  ModalCard,
  ModalRoot,
  View,
  ScreenSpinner,
  SplitLayout,
  SplitCol,
  AdaptivityProvider,
  AppRoot,
} from '@vkontakte/vkui';
import '@vkontakte/vkui/dist/vkui.css';

import {initializeApp} from 'firebase/app';
import {getDatabase, get, ref, set} from 'firebase/database';

import launchState from './ok/launchState';
import OKSDK from './ok/oksdk';

import statCore from './ok/stat';

import './App.css';

import Home from './panels/Home.js';
import Sign from './panels/Sign';

statCore.setup({
  appName: 'okoscope',
});

let db = null;

const getDB = (userId) => {
  const firebaseConfig = {
    apiKey: 'AIzaSyCJYA4iJYwsyXhThccfDNq55EUzzNYwWHY',
    authDomain: 'okoscope.firebaseapp.com',
    databaseURL:
      'https://okoscope-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'okoscope',
    storageBucket: 'okoscope.appspot.com',
    messagingSenderId: '858087644608',
    appId: '1:858087644608:web:d16e07649307374b0b7c25',
  };
  if (db === null) {
    db = getDatabase(initializeApp(firebaseConfig));
  }

  return db;
};

const getCachedValue = async (userId) => {
  const key = `subscribe-${userId}`;
  const prefix = userId.toString().startsWith('vk') ? 'vkusers/' : 'users/';
  let vall = launchState.local.getItem(key);
  if (vall === null) {
    try {
      const value = await get(ref(getDB(userId), prefix + userId));
      vall = value.val();
      if (vall !== null) {
        launchState.local.setItem(key, vall);
      }
    } catch {}
  } else {
    vall = eval(vall);
  }

  return vall;
};

const signs = [
  {
    title: 'Овен',
    title_r: 'Овнов',
    icon: 'aries',
    index: 1,
    decorator_id: 6101,
    date: '21 марта — 19 апреля',
    dateStart: 21 + (3 - 1) * 1200,
    dateEnd: 19 + (4 - 1) * 1200,
    color: '#FF5555',
  },
  {
    title: 'Телец',
    title_r: 'Тельцов',
    icon: 'taurus',
    index: 2,
    decorator_id: 6102,
    date: '20 апреля — 20 мая',
    dateStart: 20 + (4 - 1) * 1200,
    dateEnd: 20 + (5 - 1) * 1200,
    color: '#1EBB55',
  },
  {
    title: 'Близнецы',
    title_r: 'Близнецов',
    icon: 'gemini',
    index: 3,
    decorator_id: 6103,
    date: '21 мая — 20 июня',
    dateStart: 21 + (5 - 1) * 1200,
    dateEnd: 20 + (6 - 1) * 1200,
    color: '#FF8800',
  },
  {
    title: 'Рак',
    title_r: 'Раков',
    icon: 'cancer',
    index: 4,
    decorator_id: 6104,
    date: '21 июня — 22 июля',
    dateStart: 21 + (6 - 1) * 1200,
    dateEnd: 22 + (7 - 1) * 1200,
    color: '#0099FF',
  },
  {
    title: 'Лев',
    title_r: 'Львов',
    icon: 'leo',
    index: 5,
    decorator_id: 6105,
    date: '23 июля — 22 августа',
    dateStart: 23 + (7 - 1) * 1200,
    dateEnd: 22 + (8 - 1) * 1200,
    color: '#FF5555',
  },
  {
    title: 'Дева',
    title_r: 'Дев',
    icon: 'virgo',
    index: 6,
    decorator_id: 6106,
    date: '23 августа — 22 сентября',
    dateStart: 23 + (8 - 1) * 1200,
    dateEnd: 22 + (9 - 1) * 1200,
    color: '#1EBB55',
  },
  {
    title: 'Весы',
    title_r: 'Весов',
    icon: 'libra',
    index: 7,
    decorator_id: 6107,
    date: '23 сентября — 22 октября',
    dateStart: 23 + (9 - 1) * 1200,
    dateEnd: 22 + (10 - 1) * 1200,
    color: '#FF8800',
  },
  {
    title: 'Скорпион',
    title_r: 'Скорпионов',
    icon: 'scorpio',
    index: 8,
    decorator_id: 6108,
    date: '23 октября — 21 ноября',
    dateStart: 23 + (10 - 1) * 1200,
    dateEnd: 21 + (11 - 1) * 1200,
    color: '#0099FF',
  },
  {
    title: 'Стрелец',
    title_r: 'Стрельцов',
    icon: 'sagittarius',
    index: 9,
    decorator_id: 6109,
    date: '22 ноября — 21 декабря',
    dateStart: 22 + (11 - 1) * 1200,
    dateEnd: 21 + (12 - 1) * 1200,
    color: '#FF5555',
  },
  {
    title: 'Козерог',
    title_r: 'Козерогов',
    icon: 'capricorn',
    index: 10,
    decorator_id: 6110,
    date: '22 декабря — 19 января',
    dateStart: 22 + (12 - 1) * 1200,
    dateEnd: 19 + (1 - 1) * 1200,
    color: '#1EBB55',
  },
  {
    title: 'Водолей',
    title_r: 'Водолеев',
    icon: 'aquarius',
    index: 11,
    decorator_id: 6111,
    date: '20 января — 18 февраля',
    dateStart: 20 + (1 - 1) * 1200,
    dateEnd: 18 + (2 - 1) * 1200,
    color: '#FF8800',
  },
  {
    title: 'Рыбы',
    title_r: 'Рыб',
    icon: 'pisces',
    index: 12,
    decorator_id: 6112,
    date: '19 февраля — 20 марта',
    dateStart: 19 + (2 - 1) * 1200,
    dateEnd: 20 + (3 - 1) * 1200,
    color: '#0099FF',
  },
];

const tryVkConnect = (userId) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    let data;
    try {
      const parameters = {
        app_id: launchState.vkAppId,
      };
      data = await bridge.send('VKWebAppGetAuthToken', parameters);
    } catch {}

    launchState.setAccessToken(data.access_token);
    launchState.setUserId(userId);
    OKSDK.init({
      app_id: launchState.appId,
      app_key: launchState.appKey,
      location_hash: `#access_token=${launchState.getAccessToken()}`,
    });
    resolve(true);
    // Window.location.reload();
  });
};

const App = () => {
  const [activePanel, setActivePanel] = useState('home');
  const [user, setUser] = useState(null);
  const [popout, setPopout] = useState(<ScreenSpinner size="large" />);
  const [hasPopout, setHasPopout] = useState(true);

  const [isInitiallyNotificationsEnabled, setIsInitiallyNotificationsEnabled] =
    useState(false);
  const [isNotificationsEnabled, setIsNotificationsEnabled] = useState(false);

  const enableNotifications = async (userId, signIndex, isDisabler = false) => {
    const prefix = userId.toString().startsWith('vk') ? 'vkusers/' : 'users/';
    try {
      if (userId && isDisabler) {
        set(ref(getDB(userId), prefix + userId), false);
      } else {
        const data = await bridge.send('VKWebAppAllowNotifications');

        if (data.result && userId) {
          try {
            set(ref(getDB(userId), prefix + userId), signIndex);
            statCore.log('horo-subscribe-popout');
            statCore.log('horo-subscribe');
            launchState.setIsNotificationsEnabled(userId, true);
            setIsNotificationsEnabled(true);
            // Db.okuser.store({
            //   ownerUserId: okUserId,
            // });
          } catch {}
        }
      }
    } catch {
      //
    }
  };

  const disableNotifications = (userId) =>
    enableNotifications(userId, null, true);

  useEffect(() => {
    // Bridge.subscribe(({detail: {type, data}}) => {
    //   if (type === 'VKWebAppUpdateConfig') {
    //     const schemeAttribute = document.createAttribute('scheme');
    //     schemeAttribute.value = data.scheme ? data.scheme : 'client_light';
    //     document.body.attributes.setNamedItem(schemeAttribute);
    //   }
    // });

    async function fetchData() {
      try {
        if (window.location.hash === '#notif') {
          statCore.log('notification-open-no-personal');
          statCore.log('notification-open');
        }

        if (window.location.hash === '#notif-personal') {
          statCore.log('notification-open-personal');
          statCore.log('notification-open');
        }

        const urlParameters = new URLSearchParams(window.location.search);
        const isOk = urlParameters.get('vk_client') === 'ok';

        const user = await bridge.send('VKWebAppGetUserInfo');
        if (!isOk) {
          user.id = 'vk' + user.id;
          launchState.setUserId(user.id);
        }

        setUser(user);

        if (isOk && launchState.getUserId() !== user.id.toString()) {
          await tryVkConnect(user.id);
        }

        const vall = await getCachedValue(user.id);

        if (
          vall !== false &&
          vall !== null &&
          launchState.isNotificationsEnabled
        ) {
          setIsNotificationsEnabled(true);
          setIsInitiallyNotificationsEnabled(true);
        } else if (vall === false) {
          setIsInitiallyNotificationsEnabled(true);
        } else {
          statCore.log('horo-new-user-no-popout');
        }

        if (user.bdate) {
          const d = user.bdate.split('.').slice(0, 2);
          const n =
            Number.parseInt(d[0], 10) + (Number.parseInt(d[1], 10) - 1) * 1200;
          const ss = signs.find((s) => {
            if (s.dateEnd <= s.dateStart) {
              return n <= s.dateEnd || n >= s.dateStart;
            }

            return (
              s.dateStart <= n && (n <= s.dateEnd || s.dateEnd <= s.dateStart)
            );
          });
          setSign(ss);
          setActivePanel('sign');
        }
      } catch {}

      setPopout(null);
      setTimeout(() => {
        setHasPopout(false);
      }, 500);
    }

    fetchData();
  }, []);

  const go = (event) => {
    setActivePanel(event.currentTarget.dataset.to);
  };

  const [sign, setSign] = useState({});

  const [activeModal, setActiveModal] = useState(null);

  const modal = (
    <ModalRoot activeModal={activeModal} onClose={() => setActiveModal(null)}>
      <ModalCard
        actions={
          <>
            <Button
              mode="secondary"
              onClick={() => {
                disableNotifications(user?.id);
                setActiveModal(null);
              }}
              size="m"
            >
              Отменить
            </Button>
            <Button
              mode="primary"
              onClick={() => {
                enableNotifications(user?.id, sign?.index);
                setActiveModal(null);
              }}
              size="m"
            >
              Попробовать
            </Button>
          </>
        }
        header="Подписка на уведомления"
        icon={
          <svg
            fill="none"
            height="40"
            viewBox="0 0 40 40"
            width="40"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              clipRule="evenodd"
              d="M17.4835 38.3318C20.3501 38.3318 22.5668 38.3318 24.1501 38.3318C25.0668 38.3318 25.8168 37.5851 25.8168 36.6651C25.8168 35.7451 25.0668 34.9984 24.1501 34.9984C22.5668 34.9984 20.3501 34.9984 17.4835 34.9984C16.5668 34.9984 15.8168 35.7451 15.8168 36.6651C15.8168 37.5851 16.5668 38.3318 17.4835 38.3318ZM10.4168 13.2384L9.91679 19.0118L5.75012 22.3218C5.03346 22.8901 4.58346 23.7268 4.50012 24.6368L4.30012 26.9168C4.15012 28.7501 5.50012 30.3668 7.33346 30.5268C12.3168 30.9634 27.1168 32.2584 32.1001 32.6951C33.9335 32.8551 35.5501 31.4984 35.7001 29.6651L35.9001 27.3884C35.9835 26.4751 35.6835 25.5684 35.0835 24.8834L31.4668 20.8284C31.5835 19.4234 31.8501 16.3268 31.9668 15.0701C32.5168 9.09677 28.0668 3.77011 22.1001 3.31844C16.2835 2.87677 10.9501 7.25677 10.4168 13.2384ZM32.3835 29.3734L7.63346 27.2068L7.81679 24.9268C9.20012 23.8401 12.5835 21.1451 12.6001 21.1334C12.9335 20.8501 13.1335 20.4484 13.1668 20.0134C13.1668 20.0134 13.5835 15.3251 13.7335 13.5284C14.1001 9.37677 17.8168 6.33511 21.8501 6.64177C25.9668 6.95344 29.0335 10.6384 28.6501 14.7601C28.4835 16.4151 28.0835 21.2584 28.0835 21.2584C28.0335 21.6951 28.1835 22.1284 28.4501 22.4651C28.4668 22.4801 31.4001 25.7768 32.5835 27.0984V27.0968L32.3835 29.3734Z"
              fill="#999999"
              fillRule="evenodd"
            />
          </svg>
        }
        id="modal"
        onClose={() => setActiveModal(null)}
        subheader="Хотите получать напоминания о гороскопе? Подпишитесь на уведомления!"
      />
    </ModalRoot>
  );

  return (
    <AdaptivityProvider>
      <AppRoot>
        <SplitLayout modal={modal}>
          <SplitCol>
            <View activePanel={activePanel} popout={popout}>
              <Home
                go={go}
                hasPopout={hasPopout}
                id="home"
                setSign={setSign}
                signs={signs}
                user={user}
              />
              <Sign
                getDB={getDB}
                go={go}
                id="sign"
                isInitiallyNotificationsEnabled={
                  isInitiallyNotificationsEnabled
                }
                isNotificationsEnabled={isNotificationsEnabled}
                okUserId={user?.id}
                setIsInitiallyNotificationsEnabled={
                  setIsInitiallyNotificationsEnabled
                }
                setIsNotificationsEnabled={setIsNotificationsEnabled}
                sign={sign}
              />
            </View>
          </SplitCol>
        </SplitLayout>
      </AppRoot>
    </AdaptivityProvider>
  );
};

export default App;
